import { User } from "@/shared/interfaces";
import { ApiResourceResult } from "@/shared/vuex";
import { StoreOptions } from "vuex";
import { UsersClass } from "../utils";

export interface UsersVuexState extends ApiResourceResult<User> {
  users?: User[];
  loading: boolean;
}

export const UsersVuex: StoreOptions<UsersVuexState> = {
  ...{ namespaced: true },
  state: {
    users: undefined,
    loading: false,
  },
  mutations: {},
  actions: {
    /**
     * Fetches users
     * @param context
     */
    fetch(context) {
      context.state.loading = true;
      UsersClass.fetch()
        .then((resp) => {
          context.state.count = resp.count;
          context.state.next = resp.next;
          context.state.skipped = resp.skipped;
          context.state.users = resp.resources;
          //   Vue.set
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
  },
  modules: {},
  //
  getters: {},
};
